/**
 * EditorToolbar - Toolbar for the floor plan visual editor
 *
 * Controls: select mode, draw mode, pan mode, zoom in/out, fit to screen, delete
 */

import {
  Cursor,
  Rectangle,
  Hand,
  MagnifyingGlassPlus,
  MagnifyingGlassMinus,
  ArrowsIn,
  Trash,
} from '@phosphor-icons/react';
import styles from './FloorPlanEditor.module.css';

export default function EditorToolbar({
  mode, // 'select' | 'draw' | 'pan'
  onModeChange,
  onZoomIn,
  onZoomOut,
  onFitToScreen,
  onDelete,
  hasSelection,
}) {
  return (
    <div className={styles.toolbar}>
      {/* Mode buttons */}
      <div className={styles.toolbarGroup}>
        <button
          className={`${styles.toolButton} ${mode === 'select' ? styles.active : ''}`}
          onClick={() => onModeChange('select')}
          title="בחירה"
        >
          <Cursor size={20} />
        </button>
        <button
          className={`${styles.toolButton} ${mode === 'draw' ? styles.active : ''}`}
          onClick={() => onModeChange('draw')}
          title="הוסף חלל"
        >
          <Rectangle size={20} />
        </button>
        <button
          className={`${styles.toolButton} ${mode === 'pan' ? styles.active : ''}`}
          onClick={() => onModeChange('pan')}
          title="גרירה"
        >
          <Hand size={20} />
        </button>
      </div>

      <div className={styles.toolbarDivider} />

      {/* Zoom buttons */}
      <div className={styles.toolbarGroup}>
        <button className={styles.toolButton} onClick={onZoomIn} title="הגדל">
          <MagnifyingGlassPlus size={20} />
        </button>
        <button className={styles.toolButton} onClick={onZoomOut} title="הקטן">
          <MagnifyingGlassMinus size={20} />
        </button>
        <button className={styles.toolButton} onClick={onFitToScreen} title="התאם למסך">
          <ArrowsIn size={20} />
        </button>
      </div>

      <div className={styles.toolbarDivider} />

      {/* Delete */}
      <button
        className={styles.toolButton}
        onClick={onDelete}
        disabled={!hasSelection}
        title="מחק חלל"
      >
        <Trash size={20} />
      </button>

      {/* Legend */}
      <div className={styles.legend}>
        <div className={styles.legendItem}>
          <div className={styles.legendDotNew} />
          <span>חדש</span>
        </div>
        <div className={styles.legendItem}>
          <div className={styles.legendDotExisting} />
          <span>קיים</span>
        </div>
        <div className={styles.legendItem}>
          <div className={styles.legendDotChanged} />
          <span>שינוי גודל</span>
        </div>
      </div>
    </div>
  );
}
